import { Col, Row } from "react-bootstrap";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { NFLookupCompany } from "../../../Shared/NewForms/NFLookupCompany";
import { useTranslation } from "react-i18next";
import { NFLookupBaseDocuments } from "../../../Shared/NewForms/NFLookupBaseDocuments";

export const FixedAssetsWriteOffsDetailsMain = () => {
    const { t } = useTranslation();

    return (
        <>
            <Row>
                <Col sm={6}>
                    <NFTextInput
                        title={t("Document#")}
                        fieldName={"documentNumber"}
                        disabled
                    />
                </Col>
                <Col sm={6}>
                    <NFDateInput
                        title={t("DocumentDate")}
                        fieldName={"documentDate"}
                        required={true}
                    />
                </Col>
            </Row>
            <Row>
                <Col sm={6}>
                    <NFLookupCompany
                        fieldName={"companyId"}
                        title={t("Company")}
                    />
                </Col>
                <Col sm={6}>
                    <NFDateInput
                        title={t("CreatedDate")}
                        fieldName={"createdDate"}
                        required={true}
                    />
                </Col>
            </Row>
            <Row>
                <Col sm={6}>
                    <NFLookupBaseDocuments
                        fieldName={"baseDocumentAtId"}
                        title={t("BaseDocument")}
                    />
                </Col>
            </Row>
        </>
    );
};
